module.exports = __webpack_public_path__ + "img/opportunity.5111b055.png";